<template>
  <object
    v-if="src.substr(-('.svg').length) === '.svg' && !forceImg"
    :data="require(`../../assets${src}`)" :alt="alt" :width="width" :height="height" />
  <img
    v-else
    :src="require(`../../assets${src}`)" :alt="alt" :width="width" :height="height" :style="{width: width}">
</template>

<script>
export default {
  name: 'SbImage',
  props: ['src', 'alt', 'width', 'height', 'forceImg']
}
</script>